import ComponentName from "%/dynamic-component-editor/options/component-name";
import BaseDynamicComponent from "%/dynamic-component-editor/classes/base-dynamic-component";
import PageTitle from "%/dynamic-component-editor/options/page-title";
import PageDescription from "%/dynamic-component-editor/options/page-description";
import PageKeywords from "%/dynamic-component-editor/options/page-keywords";

import DisplayName from "%/dynamic-component-editor/options/display-name";
import ProvidesContexts from "%/dynamic-component-editor/options/provides-contexts";
import PageSlug from "%/dynamic-component-editor/options/page-slug";


export default class BaseDynamicPage extends BaseDynamicComponent {

  static standardOptionClasses = [
    new ComponentName("", true),
    new DisplayName("", true),
    PageTitle,
    PageKeywords,
    PageDescription,
    ProvidesContexts,
    PageSlug,
  ];
}
